<template>
  <div class="popup" v-show="show">
    <div class="popup__content">
      <span class="popup__close" @click="close()">X</span>
      <h2 class="popup__title">{{title}}</h2>
      <slot><div class="popup__text" v-html="content"></div></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Popup',
  props: ['content', 'title'],
  data() {
    return {
      show: false
    }
  },
  methods: {
    open () {
      document.querySelector('body').style.height = 'auto';
      document.querySelector('body').style.overflow = 'hidden';
      this.show = true;
    },
    close () {
      document.querySelector('body').style.height = 'auto';
      document.querySelector('body').style.overflow = 'initial';
      this.show = false;
    },
    handleClickOutside (evt) {
      if (!document.querySelector('.popup-cta').contains(evt.target) && !document.querySelector('.terms-popup').contains(evt.target) && !document.querySelector('.popup__content').contains(evt.target) && !document.querySelector('.popup__text').contains(evt.target)) {
        this.close()
      }
    },
    handleEscPressed (evt) {
      if (evt.keyCode === 27){
        this.close()
      }
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
    document.addEventListener('keyup', this.handleEscPressed);
  },
}
</script>
<style lang="scss">
  @import "./src/assets/scss/components/popup.scss";
</style>